import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import IISLogo from "assets/IISLogo.svg";
import { MenuItem } from "./types";

interface LeftPanelProps {
  menuItems: MenuItem[];
  activeMenuItem: number;
  onMenuItemClick: (index: number) => void;
  isSmallScreen: boolean;
}

export default function LeftPanel({
  menuItems,
  activeMenuItem,
  onMenuItemClick,
  isSmallScreen,
}: LeftPanelProps) {
  const { t } = useTranslation();

  return (
    <>
      {/* Welcome Section */}
      <Stack
        sx={{
          width: isSmallScreen ? "354px" : "100%",
          alignItems: "flex-start",
        }}
      >
        {!isSmallScreen && (
          <Box
            component="img"
            height={60}
            src={IISLogo}
            alt="Allinga"
            ml={-1}
          />
        )}
        <Stack sx={{ gap: 3, alignItems: "flex-start" }} pt={2}>
          <Typography variant="h3" sx={{ textAlign: "left", width: "100%" }}>
            {t("tts.introTour.title")}
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: "left", width: "100%" }}
            mb={4}
          >
            {t("tts.introTour.subtitle")}
          </Typography>
        </Stack>
      </Stack>

      {/* Topics/Menu Section */}
      <Stack
        sx={{
          width: "100%",
          flex: 1,
          gap: 2,
        }}
      >
        {menuItems.map((item, index) => (
          <Stack
            key={index}
            onClick={() => onMenuItemClick(index)}
            sx={{
              p: 1,
              backgroundColor:
                activeMenuItem === index
                  ? "rgba(0, 134, 103, 0.08)"
                  : "transparent",
              cursor: "pointer",
              "&:hover": {
                backgroundColor:
                  activeMenuItem === index ? "action.selected" : "action.hover",
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                width: isSmallScreen ? "338px" : "calc(100% - 16px)",
              }}
            >
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
